/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import { useStore } from '../../../../../store';
import { useMapContext } from '../../context/map-context';

export const TrackMouseMovement = (): JSX.Element => {
  const { mapOrigin } = useStore();
  const map = useMap();
  const { imageAngle, rangePerDegree, collapseAssetBar } = useMapContext();
  const [currentPosition, setCurrentPosition] = useState<string | null>(null);
  const [currentFtPosition, setCurrentFtPosition] = useState<string | null>(null);
  const { latitude, longitude, units } = mapOrigin.data;

  useEffect(() => {
    map.whenReady(() => {
      requestAnimationFrame(() => {
        // eslint-disable-next-line no-underscore-dangle
        if (map._mapPane) {
          map.invalidateSize();
        }
      });
    });
  }, [collapseAssetBar, map]);

  function rotatePoint(
    point: [number, number],
    center: [number, number],
    angle: number,
  ): [number, number] {
    const originLat = Number(latitude);
    const originLon = Number(longitude);

    if (!rangePerDegree || !Number.isFinite(originLat) || !Number.isFinite(originLon)) {
      return [0, 0];
    }

    const angleRad = (-angle * Math.PI) / 180; // Negative angle for matching direction
    const pointProjected = map.project(L.latLng(point));
    const centerProjected = map.project(L.latLng(center));

    const deltaX = pointProjected.x - centerProjected.x;
    const deltaY = pointProjected.y - centerProjected.y;

    const rotatedX = deltaX * Math.cos(angleRad) - deltaY * Math.sin(angleRad);
    const rotatedY = deltaX * Math.sin(angleRad) + deltaY * Math.cos(angleRad);

    const rotatedPointProjected = L.point(
      centerProjected.x + rotatedX,
      centerProjected.y + rotatedY,
    );

    const coords = map.unproject(rotatedPointProjected);

    const deltaLat = (coords.lat - Number(latitude)) * rangePerDegree.lat;
    const deltaLon = (coords.lng - Number(longitude)) * rangePerDegree.lon;

    return [parseFloat(deltaLon.toFixed(1)), parseFloat(deltaLat.toFixed(1))];
  }

  useMapEvents({
    mousemove: (e: L.LeafletMouseEvent) => {
      setCurrentPosition(` ${e.latlng.lat.toString().slice(0, 10)}, ${e.latlng.lng.toString().slice(0, 10)}`);
      const [adjustedX, adjustedY] = rotatePoint([e.latlng.lat, e.latlng.lng],
        [Number(latitude), Number(longitude)], imageAngle);
      setCurrentFtPosition(` ${adjustedX}, ${adjustedY}`);
    },
  });

  return (
    <div style={{
      margin: '0 auto',
      borderRadius: '5px',
      backgroundColor: '#4E4F52',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '20px',
      fontWeight: '600',
      fontSize: '10px',
      width: '340px',
      color: 'white',
    }}
    >
      xy = [
      {currentFtPosition}
      ]
      {` ${units} `}
      latlon = [
      {currentPosition}
      ]
    </div>
  );
};
